<template>
  <div v-if="currentNatural == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar espacio natural</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
              <natural-form :entity="currentNatural" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import NaturalForm from "./NaturalForm.vue";


    const store = useStore();
    const route = useRoute();

    const getCurrentNatural = async (id) => {
      return await store.dispatch("natural/getNaturalById", id);
    };

    const currentNatural = computed(() => {
      if(!store.state.natural.currentNatural) return null
      let nat = store.state.natural.currentNatural
      if( nat.province && nat.province['@id']){
        nat.province = nat.province['@id']
      }

      return nat
    });

    onMounted(()=>{
      getCurrentNatural(route.params.id)
    });

</script>
